import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Footer from '../Footer/FooterContainer';
import FinancialPlanHeader from '../FinancialPlanHeaderView';
import EducationChartView from '../../EducationChart/EducationChartContainer';
import ActionStepsV2 from '../ActionStepsV2/ActionStepsV2Container';
import Explanations from '../Explanations/ExplanationsContainer';
import { ASSUMPTIONS, OVERVIEW } from '../Explanations/ExplanationsConst';
import AssumptionsSectionView from '../Components/AssumptionsTable';
import educationAssumptionsLabelMap from './EducationAssumptionsConst';
import GeneralAssumptionsView from '../GeneralAssumptions';
import { Tasks } from '../../FinancialPlanOPL/Goals/components/Tasks/Tasks';

class EducationView extends Component {
  render() {
    const {
      chartData,
      chartTitle,
      clientId,
      data,
      fpId,
      isPrint,
      hasGoal,
      selectedSection,
      educationAssumption,
      goalId,
    } = this.props;

    if (!hasGoal) {
      return null;
    }

    return (
      <div
        className="NewFinancialPlan_education"
        css="page-break-inside: avoid
      "
      >
        <div
          className={`NewFinancialPlan_header
              ${!this.props.showCalibration ? ' hide-calibration-button' : ''}
          `}
        >
          <FinancialPlanHeader
            {...this.props}
            hideOldDescription={false}
            hideTrackIndicator={selectedSection === ASSUMPTIONS && isPrint}
          />
        </div>
        <section className="calibration" />
        {!isPrint && <Explanations clientId={clientId} />}
        {selectedSection === OVERVIEW && (
          <section>
            <EducationChartView
              isPrint={isPrint}
              clientId={clientId}
              Data={chartData}
              chartTitle={chartTitle}
              loaded
            />
          </section>
        )}
        {selectedSection === ASSUMPTIONS && !isPrint && (
          <div className="assumptions-container">
            <AssumptionsSectionView
              title="Education Goal Assumptions"
              valuesList={educationAssumption}
              labelList={educationAssumptionsLabelMap}
            />
            <br />
            <GeneralAssumptionsView clientId={clientId} />
          </div>
        )}

        {!isPrint && selectedSection !== ASSUMPTIONS && <Tasks />}

        {isPrint && selectedSection !== ASSUMPTIONS && (
          <ActionStepsV2 clientId={clientId} fpId={fpId} goalId={goalId} />
        )}

        {!isPrint && <Footer data={data} clientId={clientId} fpId={fpId} />}
      </div>
    );
  }
}

EducationView.defaultProps = {
  calibration: null,
};

EducationView.propTypes = {
  calibration: PropTypes.shape({}),
  clientId: PropTypes.string.isRequired,
  showCalibration: PropTypes.bool.isRequired,
  data: PropTypes.shape({}).isRequired,
  fpId: PropTypes.string.isRequired,
  goalId: PropTypes.string.isRequired,
  isCalibrating: PropTypes.func.isRequired,
  selectedGoal: PropTypes.shape({}).isRequired,
  setReactCalibrationWidget: PropTypes.func.isRequired,
  chartData: PropTypes.shape({}).isRequired,
  chartTitle: PropTypes.string.isRequired,
  isPrint: PropTypes.bool.isRequired,
  hasGoal: PropTypes.bool.isRequired,
};

export default EducationView;
